import TeamStatistics from 'components/general/TeamStatistics'

function HocTeamStats({ data }) {

  const stats = [
    { code: 'RC' },                                             // Red Cards 
    { code: 'YC' },                                             // Yellow Cards 
    { code: 'GC' },                                             // Green Cards 
    { code: 'U', paint: 'VTR', component: 'type5' },            // Team Video Referrals Upheld 
    { code: 'VTR' },                                            // Team Video Referrals Total 
    { code: 'ACP' },                                            // Attacking Circle Penetrations 
    { code: 'POSSESS' },                                        // % Possession
    { code: 'PTY', component: 'type7' },                        // Penalty Strokes 
    { code: 'PC', component: 'type7' },                         // Penalty Corner 
    { code: 'FG', component: 'type7' },                         // Field Goals 
    { code: 'Efficiency', paint: 'TOTAL', component: 'type8' }, // Shooting Efficiency (%) 
    { code: 'TOTAL', component: 'type7' }                       // Goals/Shots 

  ]
  return (<>
    <TeamStatistics data={data?.results} stats={stats} />
  </>);
}

export default HocTeamStats;